import { Injectable, NgZone, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { SseService } from './sse.service';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class EventService {
  private sseService = inject(SseService);
  private zone = inject(NgZone);

  getServerEvent<SuccessResponse = object, ErrorResponse = any>(
    subscriberId: string,
    successEventName: string,
    errorEventName: string,
    warningEventName?: string
  ): Observable<SuccessResponse | undefined> {
    const url = `${environment.api}/sse/api/v1/events/${subscriberId}`;
    return new Observable((observer) => {
      const eventSource = this.sseService.getEventSource(url);

      eventSource.onerror = (event) => {
        this.zone.run(() => {
          eventSource.close();
          observer.error(event);
        });
      };

      eventSource.addEventListener(successEventName, (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res: SuccessResponse | undefined = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.next(res);
          observer.complete();
        });
      });

      eventSource.addEventListener(errorEventName, (event) => {
        this.zone.run(() => {
          eventSource.close();
          const stringRes: string | null = event.data;
          let res: ErrorResponse | undefined = undefined;
          if (stringRes) {
            res = JSON.parse(stringRes);
          }
          observer.error(res);
        });
      });

      if (warningEventName) {
        eventSource.addEventListener(warningEventName, (event) => {
          this.zone.run(() => {
            eventSource.close();
            const stringRes: string | null = event.data;
            let res: ErrorResponse | undefined = undefined;
            if (stringRes) {
              res = JSON.parse(stringRes);
            }
            observer.error(res);
          });
        });
      }
    });
  }
}
